var _defs, _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _rect2, _path38, _path39, _rect3, _path40, _path41, _path42;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFallingPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1867.88 2787.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#17023f}.cls-4{fill:#18b2a3}.cls-5{fill:none;stroke-miterlimit:10;stroke:#602f8e;stroke-width:3px;stroke-linecap:round}.cls-6{fill:#2367af}.cls-7{fill:#ffc700}.cls-9{fill:#3e1a68}.cls-11{fill:#6a2eaf}.cls-12{fill:#197dd8}.cls-13{fill:#eab50a}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 933.94,
    x2: 933.94,
    y2: 361.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#17023f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#17023a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#17022d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17021b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 847.97,
    x2: 932.16,
    y1: 86.97,
    y2: 2732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff577",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff577",
    stopOpacity: 0
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 933.94,
    cy: 177.24,
    fill: "url(#linear-gradient)",
    rx: 933.94,
    ry: 177.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#linear-gradient-2)",
    d: "M1652.53 64.55S1424.27 0 879.34.3C486.82.54 215.07 64.64 215.07 64.64L68.38 2787.87H1799.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M742.39 1978.52c34.81 45.31 127.11 112.48 177.36 135.21 2.16 1-68.32-117.38-66.24-118.52s3.38-3.51 4.38-5.75c5.83-13.09 7.86-27.52 9.31-41.77a601.17 601.17 0 0 0 3-72.38c-.35-19.29-1.74-39-9.32-56.74-10.14-23.71-30.28-41.53-50.78-57.16a597 597 0 0 0-82.67-52.89c-33.06-17.5-34.32-70-63.24-93.69-3-2.47-56.1-11-65.74-20.57-2-2-10.86-8.69-12-4.76-3.48 12-23 38.13-19.62 49.82 14.37 50.18 134.91 286.29 175.56 339.2z",
    className: "cls-3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M412.88 1043.91a17.59 17.59 0 0 0 5.92-14c-.57-7.33-6.15-13.17-11.58-18.13s-11.35-10.19-13-17.36l-6.83 7.27c-2.9 3.09-5.84 6.23-7.75 10-3.59 7.06-3.1 15.85.56 22.87 6.55 12.52 20.92 19.99 32.68 9.35z",
    className: "cls-4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M393.69 1018.49c5.95 28.1 24 35.5 28.35 34.72",
    className: "cls-5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M399.72 1110.06l-49.1 110.74c-2 4.56 23 20 55.84 34.62s61.13 22.69 63.15 18.14l49.1-110.75z",
    className: "cls-6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M433.23 1195.05c-32.86-14.57-57.86-30.07-55.84-34.62l-6.72 15.16c-2 4.55 23 20.05 55.84 34.62s61.13 22.69 63.14 18.14l6.73-15.17c-2.02 4.56-30.29-3.57-63.15-18.13z",
    className: "cls-7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M514.67 1164.07c2.24 0 3.65-.37 4-1.26 2-4.55-23-20-55.84-34.62s-61.13-22.69-63.15-18.13c-.47 1 .53 2.69 2.72 4.77 7.49-.94 31.68 6.61 59.18 18.8 26.42 11.69 47.57 23.99 53.09 30.44z",
    className: "cls-3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M514.67 1164.07c-5.52-6.45-26.68-18.75-53-30.44-27.5-12.19-51.69-19.74-59.18-18.8 7.27 6.9 27.87 18.65 53.12 29.84 26.39 11.72 49.84 19.26 59.06 19.4zm-51.62-145.83c-5.81-6-11.13-12.84-14.5-20.91-7.74-18.51-3.32-42.71 10.34-56.74 8.6-8.83 20.89-14.8 24.35-27.24 2-7.07.51-14.63.86-22 .64-13.23 7.65-26 17.94-32.63 5.69-3.67 12.59-5.89 16.26-12 2.12-3.52 2.81-7.83 3.8-11.92 2.75-11.3 8.41-22.07 17-28.76s20.34-8.68 29.51-3.46c12.89 7.35 17.16 25.47 19 41.69.88 7.88 1.55 16 4.79 23 5.18 11.17 15.9 17.42 23.36 26.77 9.78 12.26 13.53 30.3 9.65 46.44-2.26 9.43-6.95 18.32-7.19 28-.29 11.43 5.64 21.85 6.43 33.23 1.05 15.1-7.44 29.82-18.84 38.18-20.59 15.1-50.26 14-73.67 12.54-25.14-1.43-50.89-15.32-69.09-34.19z",
    className: "cls-4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M460.48 1141.41c-2.91-34.32 38.06-61.45 54.19-91.88 26.15-49.33 27.92-108.21 41-162.49",
    className: "cls-5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M509.35 999.61a94.32 94.32 0 0 0 18.67 9.17c5.6 2.15 11.43 4.11 17.44 4.06s12.29-2.43 15.65-7.4M555.69 934a54 54 0 0 1-19.86-26",
    className: "cls-5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M553.38 1127.74a21.91 21.91 0 0 1-4.85-18.38c2-9 9.89-15.2 17.47-20.37s15.81-10.62 19.11-19.18l7.16 10.17c3 4.32 6.13 8.72 7.83 13.73 3.2 9.35 1.07 20.12-4.69 28.16-10.29 14.35-29.35 21.13-42.03 5.87z",
    className: "cls-4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M548.23 1141.41c5.22-1 29.63-17.78 38-47.13",
    className: "cls-5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6a712",
    d: "M1418.57 1434.17a2.72 2.72 0 0 0 4 .46l53.65-46a2.72 2.72 0 0 0 .16-4l-5.09-5.11a2.41 2.41 0 0 0-3.29-.13l-53.3 45.65a2.42 2.42 0 0 0-.37 3.28z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1418.68 1451.68a3.54 3.54 0 0 0 5.16.6l69.61-59.62a3.55 3.55 0 0 0 .2-5.2l-6.6-6.62a3.15 3.15 0 0 0-4.28-.17l-69.14 59.22a3.15 3.15 0 0 0-.49 4.25z",
    className: "cls-7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1260.54 864.03l.01.02v-.02h-.01zm93.3-14.74l.06.13zm-93.34 14.4s24.82-5.36 46.42-8.77c19.56-3.09 46.88-5.83 46.88-5.83l-46.52 24.3z",
    className: "cls-9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18b2a3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    d: "M1202.7 658.48l-11 4.14 23.79 63.17"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 88,
    x: 1213.3,
    y: 647.09,
    className: "cls-7",
    rx: 2,
    ry: 2,
    transform: "rotate(-20.63 1226.51199255 691.16642837)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1231.51640633 728.02955682l15.16117797-5.70777386 31.00519134 82.35701616-15.16117797 5.70777386z",
    className: "cls-7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1234.2082953 735.19647797l15.16117798-5.70777386 1.5573062 4.1365683-15.16117797 5.70777387zM1201.65302889 648.70455414l15.16117797-5.70777387 1.5573062 4.13656832-15.16117797 5.70777386z",
    className: "cls-11"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1341.67 821.09l-18.92.1-.67-130.77 9.98-19.55 8.94 19.46.67 130.76z",
    className: "cls-4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1322.08 690.42l9.98-19.55 8.94 19.46-18.92.09z",
    className: "cls-7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.75 677.35l3.31-6.48 2.96 6.45-6.27.03z",
    className: "cls-11"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.33 990.5a47.22 47.22 0 0 0 39.28-54l-13.75-87.06-.06-.13s-28.47 8.07-46.06 10.85c-20.59 3.25-47.19 3.88-47.19 3.88l13.77 87.18a47.22 47.22 0 0 0 54.01 39.28z",
    className: "cls-12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1361.4 897.37s-28.48 8.07-46.06 10.85c-20.6 3.25-47.2 3.88-47.2 3.88l3.69 23.37s26.6-.63 47.19-3.89c17.59-2.78 46.06-10.84 46.06-10.84l.06.13-3.7-23.38z",
    className: "cls-7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.55 1699.86c-61.26-12.33-66.07-62.21-64.46-78.83 1.95-19.93 16-25.85 12.2-51-4.1-26.92-8.69-21-19.51-35.59-5.88-7.9-25-157.58 24-157.58 49.46 0 15.46 48.5 49.24 43.35 12.17-1.85-6.44-71.26 50.55-68 46.83 2.67 27.47 98.42 42.17 112.67 7.67 7.44 8.64-34.77 35.83-32 44.17 4.5 10.53 112 27.67 112 10 0 6.76-45.11 49.5-37.5 58.93 10.5-2.5 211.5-80.36 205.43-15.37-1.2-29.49-8.56-43.94-13.9-12.34-4.57-31.6-11.19-43.92-4-12.62 7.44-22.63 8.24-38.97 4.95z",
    className: "cls-3"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1085 1677.85c0 1 3.67 10.33 13.34 12.83s13.16 1.5 13.16 6.17-1.66 38.83-1.66 42.33 3.83 14.67 6.33 14.67 105.67 10 104.67 10-45.34-18.17-44.34-71.33 1-50 2.17-56.5-3.62-19-11.48-24.5-82.19 66.33-82.19 66.33z",
    className: "cls-13"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1239.29 1773.18s32.66-2 49 52 19 61.34 19 61.34 20.33 57 32.66 57 52-40 66.34-63.67 24.33-43.33 31-56.67 27.66-41.66 47-44 14.66 24.67 16 32.34 3.66 33.33-15.34 43.33-28 19-46.33 45.33-61.33 88.34-76 96-26 26.67-48.33 0-62.34-89.67-64-109.66-42 24.33-42 24.33l-22-110.67z",
    className: "cls-7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M784.29 1846.35s-24.5-10.77-64.5 12.11-168.25 104.64-189 125.39-39 27-71.5 29.5-95-1-91.5 19-1 37 70.5 37 82.5-14 104-35.5 110.5-43.5 132-58 131-80 131-82.5-21-47-21-47z",
    className: "cls-13"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.54 1566.52c-25.84 4.56-40.83 27.3-40.92 43.33 0 6.48 5.5 18.17 3.5 23s-5.83 11.83-.5 27.33 5.51 27 22.17 20.34c11.91-4.8 12.83-7.84 28.66-7.84 17.13 0 31-3 39.34-20s13.33-23 9.16-31.5-27-25.35-30.5-36.66c-2.12-6.85-4.45-22.68-30.91-18zm-293.25 320s-39.5-8.67-60.5 3.83-97 85.5-115 97.5-89.5 66-127.5 63.5-101-1-101 5-20 36.5 39 47.5 67.75-5.75 80 6.5 45.5 2.5 49-12.5 19.5-19.5 27.5-19.5 114.25-46.25 127-59 36.5-46 36.5-54.5 53.5 38.29 53.5 34.9-8.5-113.23-8.5-113.23z",
    className: "cls-7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#4f287c",
    d: "M1164.62 1978.52s11.83 182.31-162.42 159.31c-106.88-14.11-130.44-58.37-173.41-138.08-22.42-41.58-28.69-155.1-93.59-184.92-74-34-66-234-144-170-54 44.31-39-205.31 83-202.36 73 1.77 66.43 154.17 105.93 193.67s12.87-126.31 89.07-126.31c65 0 61.85 74.07 57 151-9.27 147.09 64.8 238.74 83.42 257.35z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1052.29 1755.1c-8.63-8.62-6.25-15.75-25.5-26.5s-33.7-25.07-54.75-46.13-36.25-32.37-36.25-32.37 28.66-57.25 47.5-85.75a306.15 306.15 0 0 1 38.66-47.5s43.67-13 52.67-49-39.67-32.33-53.67-18.33-22.83 37.16-30.33 44.66-87.41 111.66-96.7 130-19.63 21.34-10.3 34 20.33 42 50.67 67.67 92.5 77.5 98 83 20-53.75 20-53.75z",
    className: "cls-7"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f296d",
    d: "M1009.62 1918.18l155 60.34s61.17-80.67 63.42-89.42-19.25 8.25-19.25-38.5 25-69.25 25-69.25 28.33-18.5-24.17-20.67-84.83-20.16-104.83-22-65.5 5.17-71.84 33.67-6.83 44.33-9.66 47.17-17.67 20.66-13.67 41.66 0 57 0 57z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#09011c",
    d: "M1554.6 1430.8c-.48-18.74-3.75-74.76-22-72.14-11.35 1.62 1.25 39.58-5.25 39.58-6.34 0-4.59-9.8-17.5-6.67-8.25 2-3.82 26.1-4 29.47-.14 2.75-7.25-6-16.42-4.52-14.15 2.28-4.6 38.69-.58 49 .33.86 13.69-6.93 14.36-6.31a6.5 6.5 0 0 0 3.36 1.32c4.53.86 9.12 1.72 13.71 1.36s8.72-1.83 12.93-3.3c5.67-2 17.45-3.58 21.26-8.58 3.59-4.68.27-13.85.13-19.21z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1568.71 1573.24l-62.93 10.87a3.22 3.22 0 0 1-3.66-2.38l-30.89-122.79a3.22 3.22 0 0 1 2.57-4l81.74-14.11a3.21 3.21 0 0 1 3.75 2.85l12.07 126a3.21 3.21 0 0 1-2.65 3.56z",
    className: "cls-6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1563.29 1485.69l-81.76 14.11a3.2 3.2 0 0 0-2.56 3.94l9.56 38a3.2 3.2 0 0 0 3.65 2.38l75.93-13.11a3.21 3.21 0 0 0 2.65-3.46l-3.74-39a3.19 3.19 0 0 0-3.73-2.86z",
    className: "cls-7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18b2a3",
    strokeMiterlimit: 10,
    strokeWidth: 8,
    d: "M692.61 2565.41c15.5 5.7 67-151.63 136-151.63 71 0 37 85 110 85 79.81 0 55-165 127-165 60 0 51.63 101.58 123 101.58 59.63 0 69-160.58 153-160.58 53 0 88.45 105 114 64.57"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M495.09 2634.12c-1-.47-24.69-11.79-42.34-39.1-20.38-31.53-18.42-44.13-18.13-45.46l8.06 1.76a.61.61 0 0 0 0-.15s-.36 2.75 1.55 8.95c1.76 5.73 5.87 15.65 15.41 30.42 16.38 25.34 38.69 36 38.92 36.11zm178.04-104.89l-8.23-.55c0-.25 1.45-25-12.72-51.54-8.29-15.52-15-23.92-19.13-28.23-4.5-4.68-7.06-5.69-7.09-5.7l.15.05 2.37-7.9c1.3.39 13.28 4.78 31 37.89 15.3 28.67 13.73 54.88 13.65 55.98zm-95.47 135.24a4.51 4.51 0 0 0-.3-6.35s-12.34-16-23.92-26.52c-10.65-9.72-28.59-21.4-28.59-21.4a4.51 4.51 0 0 0-6.36.29l-11.31 12.39 59.17 54z",
    className: "cls-9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M549.76 2695a4.5 4.5 0 0 1-6.33.32s-16.92-10.75-28.42-21.25c-10.59-9.65-23.75-26.35-23.75-26.35a4.5 4.5 0 0 1-.27-6.34L502.3 2629l58.77 53.62z",
    className: "cls-12"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 25.48,
    height: 89.4,
    x: 515.96,
    y: 2615.06,
    className: "cls-7",
    rx: 12.46,
    ry: 12.46,
    transform: "rotate(132.38 528.74424699 2659.7311112)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M661.63 2615a4.52 4.52 0 0 1-5.42-3.33s-8-18.54-11.6-33.78c-3.33-14-4.85-35.38-4.85-35.38a4.5 4.5 0 0 1 3.33-5.42l16.33-3.89 18.58 77.92z",
    className: "cls-9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M701.89 2605.42a4.51 4.51 0 0 0 3.35-5.39s-1.21-20-4.81-35.15c-3.31-13.94-11.54-33.55-11.54-33.55a4.49 4.49 0 0 0-5.41-3.3l-16.32 3.88 18.41 77.4z",
    className: "cls-12"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 25.48,
    height: 89.4,
    x: 668.5,
    y: 2525.2,
    className: "cls-7",
    rx: 12.46,
    ry: 12.46,
    transform: "rotate(-13.38 681.43775588 2570.41943405)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M443.61 2558.83a9.6 9.6 0 0 1-2.09.92 9.74 9.74 0 0 1-12.18-6.44 118 118 0 0 1 3.53-78.2 123.56 123.56 0 0 1 20.83-34.48 127.86 127.86 0 0 1 71.43-42.08 123.79 123.79 0 0 1 40.26-1.51 118 118 0 0 1 70.11 34.82 9.75 9.75 0 0 1-14 13.51 98.38 98.38 0 0 0-58.52-29 104 104 0 0 0-33.92 1.27 108.43 108.43 0 0 0-60.48 35.62 104.31 104.31 0 0 0-17.58 29.07 98.39 98.39 0 0 0-3 65.24 9.75 9.75 0 0 1-4.39 11.26z",
    className: "cls-4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4f287c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 10,
    d: "M1480.93 2301.36l29-44"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#197dd8",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 29,
    d: "M1460.6 2332.21l29-44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFallingPerson);
export default __webpack_public_path__ + "static/media/falling-person.82057acbe5d531c78e29f8bfa86b5d9b.svg";
export { ForwardRef as ReactComponent };